module.exports = __webpack_public_path__ + "img/5_newModelWorker_hqb.e9d2e664.png";